import * as types from './constants';

// Get Recommended Creators
export const getRecommendedCreatorsRequest = data => (
  { type: types.GET_RECOMMENDED_CREATORS_REQUEST, payload: data }
);

export const getRecommendedCreatorsDone = data => (
  { type: types.GET_RECOMMENDED_CREATORS_DONE, payload: data }
);

export const getRecommendedCreatorsFailed = errors => (
  { type: types.GET_RECOMMENDED_CREATORS_FAILED, payload: errors }
);

export const getRecommendedCreatorsReset = () => (
  { type: types.GET_RECOMMENDED_CREATORS_RESET }
);